<div class="not-found alt-column-justify-center">
  <mat-icon class="worried-icon" svgIcon="worried"></mat-icon>
  <div class="text-not-found-container">
    <p class="text-not-found alt-inter-bold alt-size-22">{{"ORGANIZATION.please-try-again" | translate}}</p>
    <p class="text-not-found alt-inter-regular alt-size-14">{{"ORGANIZATION.not-found-any" | translate}}</p>
  </div>
</div>